module.exports = __webpack_public_path__ + "img/Cupidon.3282f1c2.png";